// Test import of a JavaScript module
import './js/scripts'

// Test import of styles
import './styles/index.scss'
